import React, { Fragment, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useQuery } from "./utils/useQuery";

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setLoader] = useState(false);

  const query = useQuery();
  const eventquery = query.get('eventbtn'); 

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      return;
    }

    setLoader(true);

    try {
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret: props.formData.paymentIntentId,
        confirmParams: {
          return_url: `http://donations.hiroek.io/success?amount=${props.formData.amountWithoutCharge}&currency=${props.formData.currency}${eventquery ? "&event=true" : ""}`,
        },
      });

      setLoader(false);

      if (error) {
        setErrorMessage(error.message);
      } else {
      }
    } catch (err) {
      setLoader(false);
    }
  };

  return (
    <form className="flex flex-col justify-between min-h-screen" onSubmit={handleSubmit}>
      <div className="order-last m-6">
          <Fragment>
            <PaymentElement />

            <button
              className="px-10 py-3 my-3 mx-auto rounded-lg w-full bg-purple-700 font-medium text-sm text-white"
              type="submit"
              disabled={!stripe || !elements || isLoading}
            >
              {isLoading ? "Processing..." : "Finalise"}
            </button>

            {errorMessage && <div>{errorMessage}</div>}
          </Fragment>
      </div>
    </form>
  );
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

const PaymentForm = (props) => {
  const amount = props.payload.amount;

  const options = {
    mode: "payment",
    payment_method_types: ["card"],
    currency: props.payload.currency,
    amount: parseInt(amount),

    appearance: {},
  };
  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm
        formData={props.payload}
      />
    </Elements>
  );
};

export default PaymentForm;